<template>
  <div class="button after"
    :class="{ 'is-active': group1.afterId !== 0 }"
  >
    <span class="tip">後で見る</span>
    <button class="btn" type="button" @click="group1.onClicked">
      <IconLater class="icn" 
        :class="group1.gaClass"
        :gaClass="group1.gaClass"
       />
    </button>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from 'vue'

import * as logicButtonViewLater from '@/logic/common/ButtonViewLater'

export default defineComponent({
  props: {
    afterId: {
      type: Number,
      default: 0,
      required: true
    },
    // ブックマーク・後で見る追加APIで使うQAID/ナレッジID
    paramId: {
      type: Number,
      required: false
    },
    // ブックマーク・後で見る追加APIで使うキー(qa, knowledge)
    paramKey: {
      type: String,
      required: false
    },
    // ブックマーク・後で見る追加APIで使うページ番号
    pageNo: {
      type: String,
      required: false
    },
    // GA計測用class名
    gaClass: {
      type: String,
      required: false,
      default: ''
    }
  },
  setup (props, context) {

    const group1 = logicButtonViewLater.getGroup(props, context)

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
.button {
  &.after {
    .btn {
      border: 0;
      width: 34px;
      height: 34px;
      .icn {
        margin: 0;
        font-size: 2.0rem;
        transition: color .2s;
        color: $color-sup;
      }
    }
    &.is-active {
      .icn {
        color: $color-link;
      }
    }
  }
}
</style>
